(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/shared/assets/javascripts/api-utils.js') >= 0) return;  svs.modules.push('/components/content/shared/assets/javascripts/api-utils.js');
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

(function () {
  'use strict';

  var ContentUrlBuilder = function () {
    function ContentUrlBuilder(path, routesDomain) {
      _classCallCheck(this, ContentUrlBuilder);
      var contentApiVersion = svs.core.config.data.svsconfig.contentApiVersion || 1;
      this.path = path;
      this.routesDomain = routesDomain;
      if (!this.path) {
        throw new Error('no path-parameter specified to constructor');
      }
      this.path = path.indexOf('/') === 0 ? path : "/".concat(path);
      if (this.path.indexOf('/content') !== 0) {
        this.path = "/content/".concat(contentApiVersion).concat(this.path);
      }
      this.params = '';
      this.addParams({
        routesDomain: routesDomain || svs.core.config.data.svsconfig.routesDomain
      });
    }

    return _createClass(ContentUrlBuilder, [{
      key: "addParams",
      value: function addParams(newParams) {
        var newParamsString = Object.keys(newParams).filter(function (field) {
          return newParams[field] !== null && newParams[field] !== undefined;
        }).map(function (field) {
          return [field, newParams[field]].join('=');
        }).join('&');
        if (newParamsString) {
          this.params += (this.params ? '&' : '?') + newParamsString;
        }
        return this;
      }

    }, {
      key: "build",
      value: function build() {
        return this.path + this.params;
      }
    }]);
  }();
  var validateOptions = function validateOptions(options, requiredProperties) {
    if (!options) {
      return 'options required';
    }
    requiredProperties = requiredProperties || [];
    for (var i = 0; i < requiredProperties.length; i++) {
      if (!options[requiredProperties[i]]) {
        return "".concat(requiredProperties[i], " required");
      }
    }
    return null;
  };

  function appendUserParams(params) {
    params.userSegment = svs.core.userSession.getSegmentId() || 0;
  }

  function callJupiter(path, callback) {
    var useCallback = callback && typeof callback === 'function';
    return svs.core.jupiter.call({
      context: this,
      data: {},
      method: 'GET',
      path: path
    }, useCallback ? function (data) {
      callback(null, data);
    } : undefined, useCallback ? function (err) {
      callback(err);
    } : undefined);
  }
  svs.content.shared.ContentUrlBuilder = ContentUrlBuilder;
  svs.content.shared.appendUserParams = appendUserParams;
  svs.content.shared.validateOptions = validateOptions;
  svs.content.shared.callJupiter = callJupiter;
})();

 })(window);